<template>
    <v-container>
        <v-icon @click="openHelpDialog">
            mdi-information
        </v-icon>
        <v-dialog v-model="helpDialog" max-width="600px">
            <v-card>
                <v-card-title class="text-h5">{{ t('Ayuda') }}</v-card-title>
                <v-card-text>{{ helpText }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="helpDialog = false">{{ t('Cerrar') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { helpType } = defineProps({
    helpType: String,
});
const { t } = useI18n();

const helpDialog = ref(false);
const helpText = ref('');

const openHelpDialog = () => {
    helpDialog.value = true;
    switch (helpType) {
        case 'pregunta_texto':
            helpText.value = 'El texto de la pregunta; ej. ¿Cuantos ojos tiene una araña?.';
            break;
        case 'pregunta_orden':
            helpText.value = 'Para aquellos cuestionarios que no aleatoricen las preguntas (tipo ordenado, encuesta...), puedes establecer el orden de las preguntas con este campo, introduciendo el número de orden de la pregunta.';
            break;
        case 'pregunta_tipo':
            helpText.value = 'single_choice: una sola respuesta correcta. multiple_choice: puede haber más de una respuesta correcta. texto: el usuario puede introducir texto. relacionar: el usuario debe relacionar dos elementos. ordenar: el usuario debe ordenar una lista de elementos. relacionar_cols: el usuario debe clasificar elementos en columnas. contenido: no es una pregunta, sino contenido informativo.';
            break;
        case 'pregunta_dificultad':
            helpText.value = 'Establece la dificultad de la pregunta para futuras funcionalidades (todavía NO tiene uso).';
            break;
        case 'pregunta_imagen':
            helpText.value = 'Sube una imagen o un clip de video <8Mb que acompañe a la pregunta.';
            break;
        case 'opcion_texto':
            helpText.value = 'Texto de la posible respuesta, ej: La araña tiene 3 ojos.';
            break;
        case 'opcion_correcta':
            helpText.value = 'Marca si esta opción es la correcta o no. Solo aplica en los tipos de pregunta single_choice o multiple_choice.';
            break;
        case 'opcion_relacion':
            helpText.value = 'Solo aplica si la pregunta es de tipo relacionar o relacionar_cols. Por ejemplo, en una pregunta de relacionar, si en el campo de texto de esta opción pones taza y en el campo de relación pones café, el usuario deberá relacionar taza con café. Si la pregunta es de tipo relacionar_cols, podrías poner varias opciones de fármacos (el fármaco iría al texto de la opción) y en el campo de relación el nombre de la columna (ej endovenoso, intramuscular), entonces el usuario puede ir moviendo los fármacos para ponerlos en la columna correcta.';
            break;
        case 'opcion_orden':
            helpText.value = 'Solo aplica si la pregunta es de tipo ordenar. Establece el orden correcto de la opción en la lista de opciones.';
            break;
        case 'opcion_explicacion':
            helpText.value = 'Texto corto de feedback tras la respuesta del usuario. Ej: La araña tiene 8 ojos, no 3.';
            break;
        case 'descripcion':
            helpText.value = 'Describe tu actividad con una frase atractiva.';
            break;
        case 'presentacion':
            helpText.value = 'Haz una presentación o introducción a tu actividad.';
            break;
        case 'imagen':
            helpText.value = 'Sube una imagen representativa de la actividad.';
            break;
        case 'imagen_leccion':
            helpText.value = 'Sube una imagen o un video de máximo 8Mb. Los formatos de video aceptados son .mp4, .webm y .ogg';
            break;
        case 'imagen_posicion':
            helpText.value = 'Arriba implica que la imagen está arriba del todo de la lección, si hay varias se veran en carousel. Lateral implica que la imagen estará abajo, si hay varias estarán una al lado de la otra';
            break;
        case 'imagen_descripcion':
            helpText.value = 'Pie de imagen, visible en las imágenes que están en posición lateral, en las de arriba no se ve.';
            break;
        case 'profesional':
            helpText.value = '¿A qué profesionales va dirigida tu actividad? Marca todos los que apliquen.';
            break;
        case 'director':
            helpText.value = 'El director es la persona responsable del contenido de la actividad. El director puede editar el contenido de su actividad y su acceso por parte de otros usuarios.';
            break;
        case 'docentes':
            helpText.value = 'Puedes dar acceso docente a otros profesionales registrados que estén relacionados con la especialidad o categoría profesional de tu actividad. Los docentes tienen acceso a la guía docente de la actividad y pueden evaluar los alumnos.';
            break;
        case 'administradores':
            helpText.value = 'Puedes dar acceso de administrador a otros profesionales de tu organización. Los administradores tienen acceso de edición a todo el contenido de la actividad.';
            break;
        case 'areas':
            helpText.value = '¿En qué URLs tiene que estar disponible tu actividad? Por defecto selecciona vallhebron (vallhebron.simulacio.com). Si deseas que tu actividad esté disponible en alguna de las otras URLs (por ejemplo gine.simulacio.com), seleccionalas.';
            break;
        case 'afos':
            helpText.value = 'El código AFOS sirve para identificar tu actividad en el Centre de Simulació. Para que el control de asistencia con QR funcione correctamente es fundamental que el código coincida exactamente con el código introducido en el sistema RedCap del centro.';
            break;
        case 'porcentaje_teorico':
            helpText.value = 'Qué porcentaje de la nota final corresponde a la teoría (los tests online).';
            break;
        case 'puntaje_practico_diez':
            helpText.value = 'Qué puntaje corresponde a una nota de 10 (para los cuestionarios competitivos que dan puntos).';
            break;
        case 'video_url':
            helpText.value = 'Pega la UDL del video aquí. Cuidado, la URL normal de la web no sirve, tiene que ser la URL embedded. Se obtiene haciendo clic con el botón secundario encima del video.';
            break;
        default:
            helpText.value = 'Información no disponible.';
    }
};

</script>